import { defineComponent as _defineComponent } from 'vue'
import CollapsableCard from "@/components/bootstrap/CollapsableCard.vue";
import Toggle from "@/components/bootstrap/Toggle.vue";
import {useTranslations} from "@/hooks/useTranslations";
import {debounce} from "@/utils/Helpers";
import {Allergens} from "@/models/NutritionLabels/Allergens";
import {computed, inject, ref, watch} from "vue";
import {splitLanguages} from "@/models/NutritionLabels/v2/Helpers";
import {LabelLanguage} from "@/models/NutritionLabels/LabelLanguage";

type AllergensConfigurationProps = {
  value: Allergens[],
  language: keyof typeof LabelLanguage
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AllergensConfiguration',
  props: {
    value: null,
    language: null
  },
  emits: ["fetch-preview", "update:value", "update:mayContainText"],
  setup(__props: any, { emit }) {

const props = __props as {
  value: Allergens[],
  language: keyof typeof LabelLanguage
};

const fetchPreview: () => void = inject("bopFetchPreview");



const translations = useTranslations();

const iterableAllergens = computed(() => Object.keys(Allergens).filter((key) => isNaN(Number(key))));
const languageHeaders = computed(() => {
  return splitLanguages(LabelLanguage[props.language]).map((l) => translations.value.get(LabelLanguage[l]));
});

const model = ref(props.value.map((a) => a.toString()));
const mayContainText = ref<string[][]>([]);

watch(
  () => props.value,
  (newVal) => {
    model.value = newVal.map((a) => a.toString());
  },
  { deep: true, immediate: true }
);

function onAllergenToggled(allergen: string, isChecked: boolean) {
  if (isChecked) {
    model.value.push(allergen);
  }

  else {
    model.value = model.value.filter((x) => x != allergen);
  }

  emit('update:value', model.value.map((a) => Allergens[a]));
  debouncedFetchPreview();
}

function onTagAdded() {
  emit("update:mayContainText", mayContainText);
  debouncedFetchPreview();
}

function debouncedFetchPreview() {
  debounce(fetchPreview, 1000, "back-of-package-config-label-update");
}

return { __sfc: true,fetchPreview, props, emit, translations, iterableAllergens, languageHeaders, model, mayContainText, onAllergenToggled, onTagAdded, debouncedFetchPreview, CollapsableCard, Toggle, Allergens }
}

})